import { useEffect, useRef, useState, useMemo } from "react"
import axios from "axios"
import Icon from "components/planning_center_icon"
import pcoUrl from "@planningcenter/url"
import AccountCenterSearch from "components/admin/account_center_search/account_center_search"
import { Box, Spinner } from "@planningcenter/tapestry-react"
import { HelperShelfMessage, HelperShelfTrigger } from "components/helper_shelf"

const Managers = ({ siteAdminAccountCenterIds, event, ...props }) => {
  const [managers, setManagers] = useState(props.managers)
  const [selectedPerson, setSelectedPerson] = useState(null)
  const [creatingNewManager, setCreatingNewManager] = useState(false)
  const [deletingManager, setDeletingManager] = useState(false)
  const disabledItemCondition = item => {
    return siteAdminAccountCenterIds.includes(item.account_center_id)
  }

  const resetFormFunc = useRef(null)

  useEffect(() => {
    if (!creatingNewManager && typeof resetFormFunc.current === "function") {
      resetFormFunc.current()
    }
  }, [creatingNewManager])

  const selectPerson = (person, state) => {
    if (person) {
      setSelectedPerson(person.account_center_id)
      setCreatingNewManager(true)
      if (
        typeof resetFormFunc.current !== "function" &&
        state &&
        typeof state.clearSelection === "function"
      ) {
        resetFormFunc.current = state.clearSelection
      }
    }
  }

  const handleDeleteManagerClick = manager => {
    if (deletingManager !== manager.id) {
      setDeletingManager(manager.id)
      axios
        .post(
          `${pcoUrl(railsEnv)("api")}/registrations/v2/events/${event.id}/remove_manager`,
          {
            person_id: manager.id
          },
          {
            withCredentials: true,
            headers: {
              "X-CSRF-Token": $.rails.csrfToken()
            }
          }
        )
        .then(resp => {
          setDeletingManager(null)
          setManagers(resp.data.data)
        })
    }
  }

  useEffect(() => {
    if (selectedPerson) {
      axios
        .post(
          `${pcoUrl(railsEnv)("api")}/registrations/v2/events/${event.id}/add_manager`,
          {
            new_person_account_center_id: selectedPerson
          },
          {
            withCredentials: true,
            headers: {
              "X-CSRF-Token": $.rails.csrfToken()
            }
          }
        )
        .then(resp => {
          setManagers(resp.data.data)
          setCreatingNewManager(false)
          setSelectedPerson(null)
        })
    }
  }, [event.id, selectedPerson])

  const sortedMangers = useMemo(() => {
    return managers.sort((a, b) => {
      return a.attributes.name.toUpperCase() > b.attributes.name.toUpperCase() ? 1 : -1
    })
  }, [managers])
  return (
    <div className="p-r">
      <AccountCenterSearch
        onSelect={selectPerson}
        disabledItemCondition={disabledItemCondition}
        DisableditemRenderer={DisabledSearchResult}
        inputProps={{
          disabled: creatingNewManager,
          placeholder: "Search for someone to promote",
          autoFocus: false
        }}
        showSpinner={creatingNewManager}
        menuProps={{
          style: { zIndex: 1 }
        }}
      />
      <div className="managers-list">
        <ul className="action-list mb-0 unstyled">
          {sortedMangers.map(manager => (
            <Manager
              key={manager.id}
              manager={manager}
              onClick={handleDeleteManagerClick}
              showSpinner={deletingManager === manager.id}
            />
          ))}
          <li className="p-1 action-list__item">
            All Registrations Administrators
            <HelperShelfTrigger id="registrations_admins_as_managers" className="p-r t-1p pl-1" />
          </li>
        </ul>
        <HelperShelfMessage id="registrations_admins_as_managers">
          Registrations Administrators can create, view, and modify all signups in your account.
        </HelperShelfMessage>
      </div>
    </div>
  )
}

const Manager = ({ manager, onClick, showSpinner = false }) => {
  const {
    attributes: { name }
  } = manager
  return (
    <li className="d-f jc-sb action-list__item">
      <div className="p-1">{name}</div>
      {showSpinner ? (
        <Box paddingHorizontal={2} paddingTop={1}>
          <Spinner size="xs" />
        </Box>
      ) : (
        <button
          className={`action-list-item__remove ${showSpinner && "active"}`}
          onClick={() => onClick(manager)}
        >
          <span className="p-r t-2p">
            <Icon symbol="general#x" aria-label="Remove this manager from this signup" />
          </span>
        </button>
      )}
    </li>
  )
}

const DisabledSearchResult = ({ item, getItemProps, index }) => {
  return (
    <li
      {...getItemProps({
        key: item.account_center_id,
        index,
        item,
        disabled: true,
        className: "autocomplete-result inactive"
      })}
    >
      <button className="autocomplete-result__link">
        <div className="mr-1">
          <img src={item.cropped_avatar_url} alt={item.name} className="w-5 h-5 circle" />
        </div>
        <div className="autocomplete-result__details-wrapper fw-w">
          <div className="d-f ai-c">
            <div className="autocomplete-result__name">{item.name}</div>
            <span className="ml-1 badge badge--subtle badge--tiny">Admin</span>
          </div>
          <div className="w-100% mt-4p">Admins can manage all signups</div>
        </div>
      </button>
    </li>
  )
}

export default Managers
